import {createSvgIcon} from './utils'

export default createSvgIcon(
  <path
    clipRule="evenodd"
    d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM15.5786 13.156L11.8173 17.472H14.9373L19.6866 12.1333L14.9373 6.79468H11.8173L15.5786 11.1107H4.88397V13.156H15.5786Z"
    fillRule="evenodd"
  />,
  'ArrowInCircle',
)
